import {Action} from "redux";
import {
    CreateMessageRoomByClientRequest,
    SendMessageByClientRequest
} from "../request/message_room_request";
import {
    CreateMessageRoomByClientResponse,
    ObserveMessageRoomByClientResponse,
} from "../response/message_room_response";


export enum ClientMessageRoomActionType {

    REQUEST_CREATE_MESSAGE_ROOM = "CLIENT_MESSAGE_ROOM_REQUEST_CREATE_MESSAGE_ROOM",
    CALLBACK_CREATE_MESSAGE_ROOM = "CLIENT_MESSAGE_ROOM_CALLBACK_CREATE_MESSAGE_ROOM",
    REQUEST_SEND_MESSAGE_ROOM = "CLIENT_MESSAGE_ROOM_REQUEST_SEND_MESSAGE_ROOM",
    CALLBACK_SEND_MESSAGE_ROOM = "CLIENT_MESSAGE_ROOM_CALLBACK_SEND_MESSAGE_ROOM",
    REQUEST_DESTROY_MESSAGE_ROOM = "CLIENT_MESSAGE_ROOM_REQUEST_DESTROY_MESSAGE_ROOM",
    CALLBACK_DESTROY_MESSAGE_ROOM = "CLIENT_MESSAGE_ROOM_CALLBACK_DESTROY_MESSAGE_ROOM",
    CALLBACK_OBSERVE_MESSAGE_ROOM = "CLIENT_MESSAGE_ROOM_CALLBACK_OBSERVE_MESSAGE_ROOM",

}

export interface IRequestCreateMessageRoomAction extends Action {
    type: ClientMessageRoomActionType.REQUEST_CREATE_MESSAGE_ROOM;
    item: CreateMessageRoomByClientRequest;
}

export interface ICallbackCreateMessageRoomAction extends Action {
    type: ClientMessageRoomActionType.CALLBACK_CREATE_MESSAGE_ROOM;
    isSuccess: boolean;
    item?: CreateMessageRoomByClientResponse;
    error?: any;
}

export interface IRequestSendMessageRoomAction extends Action {
    type: ClientMessageRoomActionType.REQUEST_SEND_MESSAGE_ROOM;
    item: SendMessageByClientRequest,
}

export interface ICallbackSendMessageRoomAction extends Action {
    type: ClientMessageRoomActionType.CALLBACK_SEND_MESSAGE_ROOM;
    isSuccess: boolean;
    error?: any;
}

export interface IRequestDestroyMessageRoomAction extends Action {
    type: ClientMessageRoomActionType.REQUEST_DESTROY_MESSAGE_ROOM;
}

export interface ICallbackDestroyMessageRoomAction extends Action {
    type: ClientMessageRoomActionType.CALLBACK_DESTROY_MESSAGE_ROOM;
    isSuccess: boolean;
    error?: any;
}

export interface ICallbackObserveMessageRoomAction extends Action {
    type: ClientMessageRoomActionType.CALLBACK_OBSERVE_MESSAGE_ROOM;
    isSuccess: boolean;
    item?: ObserveMessageRoomByClientResponse;
    error?: any;
}

export type ClientMessageRoomAction =
    IRequestCreateMessageRoomAction |
    ICallbackCreateMessageRoomAction |
    IRequestSendMessageRoomAction |
    ICallbackSendMessageRoomAction |
    IRequestDestroyMessageRoomAction |
    ICallbackDestroyMessageRoomAction |
    ICallbackObserveMessageRoomAction
    ;

export interface IClientMessageRoomActionCreator {
    requestCreateMessageRoomAction(
        item: CreateMessageRoomByClientRequest,
    ): IRequestCreateMessageRoomAction;

    callbackCreateMessageRoomAction(
        isSuccess: boolean,
        item?: CreateMessageRoomByClientResponse,
        error?: any,
    ): ICallbackCreateMessageRoomAction;

    requestSendMessageRoomAction(
        item: SendMessageByClientRequest,
    ): IRequestSendMessageRoomAction;

    callbackSendMessageRoomAction(
        isSuccess: boolean,
        error?: any,
    ): ICallbackSendMessageRoomAction;

    requestDestroyMessageRoomAction(): IRequestDestroyMessageRoomAction;

    callbackDestroyMessageRoomAction(
        isSuccess: boolean,
        error?: any,
    ): ICallbackDestroyMessageRoomAction;

    callbackObserveMessageRoomAction(
        isSuccess: boolean,
        item?: ObserveMessageRoomByClientResponse,
        error?: any,
    ): ICallbackObserveMessageRoomAction;
}

class ActionCreator implements IClientMessageRoomActionCreator {

    public requestCreateMessageRoomAction = (
        item: CreateMessageRoomByClientRequest,
    ): IRequestCreateMessageRoomAction => {
        return {
            type: ClientMessageRoomActionType.REQUEST_CREATE_MESSAGE_ROOM,
            item,
        };
    };

    public callbackCreateMessageRoomAction = (
        isSuccess: boolean,
        item?: CreateMessageRoomByClientResponse,
        error?: any,
    ): ICallbackCreateMessageRoomAction => {
        return {
            type: ClientMessageRoomActionType.CALLBACK_CREATE_MESSAGE_ROOM,
            isSuccess,
            item,
            error,
        };
    };

    public requestSendMessageRoomAction = (
        item: SendMessageByClientRequest,
    ): IRequestSendMessageRoomAction => {
        return {
            type: ClientMessageRoomActionType.REQUEST_SEND_MESSAGE_ROOM,
            item,
        };
    };

    public callbackSendMessageRoomAction = (
        isSuccess: boolean,
        error?: any,
    ): ICallbackSendMessageRoomAction => {
        return {
            type: ClientMessageRoomActionType.CALLBACK_SEND_MESSAGE_ROOM,
            isSuccess,
            error,
        };
    };

    public requestDestroyMessageRoomAction = (): IRequestDestroyMessageRoomAction => {
        return {
            type: ClientMessageRoomActionType.REQUEST_DESTROY_MESSAGE_ROOM,
        };
    };

    public callbackDestroyMessageRoomAction = (
        isSuccess: boolean,
        error: any,
    ): ICallbackDestroyMessageRoomAction => {
        return {
            type: ClientMessageRoomActionType.CALLBACK_DESTROY_MESSAGE_ROOM,
            isSuccess,
            error,
        };
    };

    public callbackObserveMessageRoomAction = (
        isSuccess: boolean,
        item?: ObserveMessageRoomByClientResponse,
        error?: any,
    ): ICallbackObserveMessageRoomAction => {
        return {
            type: ClientMessageRoomActionType.CALLBACK_OBSERVE_MESSAGE_ROOM,
            isSuccess,
            item,
            error,
        };
    };
}

export const createClientMessageRoomActionCreator = (): IClientMessageRoomActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_message_room_action.ts